// Agenda de visitas (AgendarForm, BookingModal, ManageAppointment, AppointmentsManagerModal, tokenAppointment, CalendarGrid) — Español.
//
// Existe en es, pt y en (mismas claves; `npm run test:i18n-en-paridad` lo verifica).
// Estos textos estaban fijos en español en el código: cada valor de acá tiene que
// ser IDÉNTICO al literal que reemplaza (espacios incluidos). Los `{{x}}` los
// completa `fill` de components/booking/bookingShared.
export const bookingEs = {
  common: {
    branch: 'Sucursal',
    branchNumber: 'Sucursal #{{id}}',
    viewMyAppointments: 'Ver mis citas',
    edit: 'Editar',
    yourData: 'Tus datos',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    firstNamePlaceholder: 'Juan',
    lastNamePlaceholder: 'Pérez',
    emailPlaceholder: 'correo@dominio.com',
    phonePlaceholder: '+569...',
    saveMyData: 'Guardar mis datos',
    noteOptional: 'Nota (opcional)',
    notePlaceholder: 'Ej: Voy con acompañante, prefiero ver el maletero, etc.',
    selectBranchAria: 'Seleccionar sucursal',
    selectBranchPlaceholder: 'Selecciona una sucursal',
    grayDaysHint: 'Los días grises se muestran para conservar la vista de calendario, pero no tienen horarios.',
    slotsFor: 'Horarios para {{date}}',
    noSlots: 'No hay horarios disponibles para esa fecha. Prueba con otro día.',
    visitReason: 'Motivo de tu visita',
    bookVisit: 'Agendar visita',
    bookAnother: 'Agendar otra visita',
    cancelAppointment: 'Cancelar cita',
    close: 'Cerrar',
    back: 'Volver',
  },
  // Etiqueta visible de cada motivo. El VALOR guardado (service_name) no cambia.
  reasons: {
    verVehiculo: 'Ver un vehículo',
    tasarAuto: 'Tasar mi auto',
    financiamiento: 'Financiamiento',
    otraConsulta: 'Otra consulta',
    consignarAuto: 'Consignar mi auto',
    venderAuto: 'Vender mi auto',
    visitaShowroom: 'visita showroom',
    visita: 'visita',
  },
  toast: {
    slotsLoadError: 'Error cargando horarios: {{error}}',
    missingClientId: 'Falta client_id',
    completeData: 'Completa tus datos correctamente',
    dataSaved: 'Datos guardados',
    dataSaveFailed: 'No se pudieron guardar tus datos',
    completeToContinue: 'Completa tus datos para continuar.',
    completeAndSaveToContinue: 'Completa y guarda tus datos para continuar.',
    emailFailed: 'Cita agendada, pero no pudimos enviar la confirmación a tu email.',
    slotTaken: 'Esa hora acaba de ser tomada. Elige otro horario.',
    alreadyBooked: 'Ya tienes una cita en ese horario.',
    tooMany: 'Ya tienes el máximo de citas activas. Cancela una para agendar otra.',
    slotUnavailable: 'Ese horario ya no está disponible. Elige otro.',
    createFailed: 'No se pudo crear la cita: {{code}}',
    booked: '¡Cita agendada con éxito!',
    // #228: la automotora todavía tiene que aceptarla. No se dice "agendada".
    requested: 'Solicitud enviada. La automotora va a confirmar tu visita.',
  },
  email: {
    confirmSubject: 'Confirmación de cita: {{reason}}',
    newSubject: 'Nueva cita: {{reason}}',
    confirmSubjectVehicle: 'Confirmación de Cita: {{vehicle}}',
    newSubjectVehicle: 'Nueva Cita Agendada: {{vehicle}}',
    // #228: los cuatro asuntos de una cita que espera ser aceptada. Al
    // cliente, que es una solicitud; a la automotora, que hay que responder.
    requestSubject: 'Recibimos tu solicitud de cita: {{reason}}',
    newPendingSubject: 'Nueva cita POR ACEPTAR: {{reason}}',
    requestSubjectVehicle: 'Recibimos tu solicitud de cita: {{vehicle}}',
    newPendingSubjectVehicle: 'Nueva cita POR ACEPTAR: {{vehicle}}',
    sellerSubject: 'Nueva Cita para tu vehículo: {{brand}} {{model}}',
    cancelledSubject: 'Cita Cancelada: {{brand}} {{model}}',
    cancelledSellerSubject: 'Cita Cancelada para tu vehículo: {{brand}} {{model}}',
    customerFallback: 'Cliente',
  },
  calendar: {
    prevMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
    noSlots: 'Sin horarios disponibles',
    loadingMonth: 'Cargando disponibilidad del mes…',
    wd0: 'D',
    wd1: 'L',
    wd2: 'M',
    wd3: 'X',
    wd4: 'J',
    wd5: 'V',
    wd6: 'S',
  },
  // AgendarForm (/agendar y bloque del builder)
  form: {
    title: 'Agenda tu visita',
    subtitleBefore: 'Reserva un horario con ',
    subtitleAfter: ' y te esperamos.',
    subtitleFallbackName: 'nosotros',
    stepDayTime: 'Día y hora',
    stepReasonData: 'Motivo y datos',
    stepConfirm: 'Confirmar',
    done: '¡Listo!',
    expectOn: 'Te esperamos el ',
    // #228: el panel cuando la visita espera que la acepten. "Te esperamos"
    // es una promesa que la automotora todavía no hizo.
    doneRequested: '¡Solicitud enviada!',
    requestedOn: 'Pediste el ',
    requestedNote: 'Te vamos a confirmar en cuanto la revisemos. La hora queda reservada mientras tanto.',
    expectAt: ' a las ',
    expectIn: ' en',
    reasonPrefix: 'Motivo: ',
    loadingBranches: 'Cargando sucursales…',
    chooseDay: 'Elige un día',
    chooseSlot: 'Elige un horario',
    pickDateFirst: 'Primero elige una fecha en el calendario.',
    reviewConfirm: 'Revisa y confirma',
    summaryDay: 'Día',
    summaryTime: 'Hora',
    summaryReason: 'Motivo',
    summaryName: 'A nombre de',
    summaryNote: 'Nota',
    back: 'Atrás',
    continue: 'Continuar',
  },
  // BookingModal (ficha del vehículo)
  modal: {
    selectBranch: 'Selecciona sucursal',
    timezone: 'Zona horaria: ',
    stepDate: 'Fecha',
    stepTime: 'Horario',
    manageTooltip: 'Revisa y administra tus citas',
    selectDate: 'Selecciona una fecha',
    pickDateFirst: 'Primero elige una fecha.',
    summary: 'Resumen',
    chooseDate: 'Elegir fecha',
    chooseTime: 'Elegir horario',
    confirm: 'Confirmar cita',
  },
  // AppointmentsManagerModal ("Mis citas")
  manager: {
    title: 'Mis citas',
    fetchFailed: 'No se pudo obtener las citas',
    pastCannotCancel: 'No es posible cancelar una cita pasada.',
    notFound: 'No se encontró la cita',
    cancelFailedMaybe: 'No se pudo cancelar la cita (puede que ya haya pasado o ya esté cancelada).',
    cancelled: 'Cita cancelada',
    cancelFailed: 'No se pudo cancelar la cita',
    empty: 'No tienes citas próximas.',
    note: 'Nota:',
    rescheduleHelp: 'Para reprogramar, cancela y vuelve a agendar.',
    help: 'Ayuda',
    confirmTitle: 'Confirmar cancelación',
    confirmText: '¿Deseas cancelar esta cita? Puedes indicar un motivo (opcional).',
    reasonPlaceholder: 'Ej: No podré asistir, necesito reprogramar, etc.',
    // Estado crudo de la base: en español se ve tal cual, como siempre.
    statusPending: 'pending',
    statusConfirmed: 'confirmed',
  },
  // ManageAppointment (/agendar/gestionar)
  manage: {
    title: 'Gestionar mi visita',
    notFoundHint: 'Si la agendaste hace poco, revisá el enlace del mensaje que te llegó.',
    cancelledTitle: 'Tu visita fue cancelada.',
    cancelledText: 'Si querés venir otro día, podés agendar de nuevo cuando quieras.',
    rescheduledTitle: 'Tu cita fue reagendada.',
    rescheduledText: 'Te esperamos en el horario nuevo.',
    date: 'Fecha',
    time: 'Hora',
    reason: 'Motivo',
    viewDetail: 'Ver el detalle de mi visita',
    stepConfirm: 'Confirmar',
    whichDay: '¿Qué día te queda mejor?',
    whichTime: '¿A qué hora?',
    noSlotsLeft: 'No quedan horarios ese día. Probá con otro.',
    confirmChange: 'Confirmá el cambio',
    newDate: 'Nueva fecha',
    newTime: 'Nueva hora',
    keepsNote: 'La sucursal y el motivo se mantienen. Tu horario anterior queda liberado.',
    confirmNewSlot: 'Confirmar nuevo horario',
    wasRescheduled: 'Esta visita fue reagendada.',
    leftForOn: 'Tu visita quedó para el ',
    leftForAt: ' a las ',
    viewNewVisit: 'Ver mi visita nueva',
    cancelledState: 'Esta visita está cancelada. Si querés venir otro día, podés agendar de nuevo.',
    doneState: 'Esta visita ya se realizó. ¡Gracias por venir!',
    tooSoon: 'Falta muy poco para tu visita. Si no vas a poder venir, llamá a la sucursal.',
    reschedule: 'Reagendar',
    confirmCancelQuestion: '¿Querés cancelar tu visita?',
    confirmCancelText: 'Vas a perder el horario. Podés agendar otro después.',
    yesCancel: 'Sí, cancelar',
    noBack: 'No, volver',
  },
  // src/app/agendar/page.tsx (host sin tenant)
  page: {
    unavailableTitle: 'Agenda no disponible',
    unavailableText: 'No pudimos identificar la automotora. Revisa el enlace e inténtalo nuevamente.',
  },
};
